// extracted by mini-css-extract-plugin
module.exports =  {"coordinate":"Draggable-dsab__coordinate","coordinate__label":"Draggable-y6du__coordinate__label","draggable":"Draggable-o8ZG__draggable"};